module.exports = __webpack_public_path__ + "static/media/12. Puff Fans 300 g.b528f109.jpg";